import { useMemo } from "react";
import { Procedure } from "@app/projects/network-assessment/provider-hub/interfaces";
import ProviderHubService from "@app/projects/network-assessment/provider-hub/providerHubService";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";
import { useQuery } from "@tanstack/react-query";

export interface TopProceduresResult {
  data: DropdownItem<string>[];
  hasData: boolean;
  isError: boolean;
  isLoading: boolean;
}

export const TOP_PROCEDURES_QUERY_PREFIX = "provider-hub__top-procedures";

export const useTopProcedures = (projectId: number | undefined, projectRunConfigurationId: number | undefined, enabled: boolean): TopProceduresResult => {
  const providerHubService = useMemo(() => new ProviderHubService(), []);

  const queryResult = useQuery<Procedure[]>({
    enabled: enabled && !!projectId && !!projectRunConfigurationId,
    queryFn: async ({ signal }) => providerHubService.getTopProcedures(projectId, projectRunConfigurationId, signal),
    queryKey: [TOP_PROCEDURES_QUERY_PREFIX, projectId, projectRunConfigurationId],
    staleTime: 5 * 60 * 1000,
  });

  return {
    data: queryResult.data?.map(p => ({ key: p.code, name: `${p.code} - ${p.description}` })) ?? [],
    hasData: queryResult.isSuccess && queryResult.data?.length > 0,
    isError: queryResult.isError,
    isLoading: queryResult.isPending,
  };
}